import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { doubleArrow, SlIcon, useIcons } from '@sololearnorg/icons';

import s from './LevelZone.scss';

export enum LevelIndicator {
    UP = 1,
    FREEZE,
    DOWN,
}

export interface ILevelZoneProps {
    zone: LevelIndicator;
    btsBonusText?: string;
    isBackToSchoolEnabled?: boolean;
}

export function LevelZone({
	zone,
	btsBonusText,
	isBackToSchoolEnabled,
}: ILevelZoneProps): JSX.Element {
	useStyles(s);
	useIcons([doubleArrow]);
	return (
		<div className="sl-leaderboard-zone">
			{zone === LevelIndicator.UP ? (
				<>
					<div className="sl-leaderboard-zone__wrapper sl-leaderboard-zone--up">
						<div className="sl-leaderboard-zone__icon sl-leaderboard-zone__icon--up">
							<SlIcon iconId="doubleArrow" />
						</div>
						<p className="sl-leaderboard-zone__title">
							Level-up zone
						</p>
						<div className="sl-leaderboard-zone__icon sl-leaderboard-zone__icon--up">
							<SlIcon iconId="doubleArrow" />
						</div>
					</div>
					{isBackToSchoolEnabled && (
						<div className="sl-leaderboard-zone__btsText">
							{btsBonusText}
						</div>
					)}
				</>
			) : null}
			{zone === LevelIndicator.DOWN ? (
				<div className="sl-leaderboard-zone__wrapper sl-leaderboard-zone--down">
					<div className="sl-leaderboard-zone__icon sl-leaderboard-zone__icon--down">
						<SlIcon iconId="doubleArrow" />
					</div>
					<p className="sl-leaderboard-zone__title">
						Level-down zone
					</p>
					<div className="sl-leaderboard-zone__icon sl-leaderboard-zone__icon--down">
						<SlIcon iconId="doubleArrow" />
					</div>
				</div>
			) : null}
		</div>
	);
}
